import { ThemeProvider } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import lightTheme from "theme/lightTheme";
import "./style/index.scss";
import { CommonComponents } from "pages/common";
import { DayOrders, Dispatch, LockScreen, Login, Orderoverview } from "pages";

export default function App() {
  return (
    <ThemeProvider theme={lightTheme}>
      <CommonComponents />
      <Routes>
        <Route index path="/" element={<LockScreen />} />
        <Route path="/login" element={<Login />} />
        <Route path="/day-overview" element={<DayOrders />} />
        <Route path="/week-overview" element={<Dispatch />} />
        <Route path="/order-overview" element={<Orderoverview />} />
      </Routes>
    </ThemeProvider>
  );
}
